/* This is generated code, don't alter */
var IfcTimeSeriesDataTypeEnum;
(function (IfcTimeSeriesDataTypeEnum) {
    IfcTimeSeriesDataTypeEnum[IfcTimeSeriesDataTypeEnum["CONTINUOUS"] = 0] = "CONTINUOUS";
    IfcTimeSeriesDataTypeEnum[IfcTimeSeriesDataTypeEnum["DISCRETE"] = 1] = "DISCRETE";
    IfcTimeSeriesDataTypeEnum[IfcTimeSeriesDataTypeEnum["DISCRETEBINARY"] = 2] = "DISCRETEBINARY";
    IfcTimeSeriesDataTypeEnum[IfcTimeSeriesDataTypeEnum["PIECEWISEBINARY"] = 3] = "PIECEWISEBINARY";
    IfcTimeSeriesDataTypeEnum[IfcTimeSeriesDataTypeEnum["PIECEWISECONSTANT"] = 4] = "PIECEWISECONSTANT";
    IfcTimeSeriesDataTypeEnum[IfcTimeSeriesDataTypeEnum["PIECEWISECONTINUOUS"] = 5] = "PIECEWISECONTINUOUS";
    IfcTimeSeriesDataTypeEnum[IfcTimeSeriesDataTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcTimeSeriesDataTypeEnum || (IfcTimeSeriesDataTypeEnum = {}));
const IfcTimeSeriesDataTypeEnumCount = 7;
export { IfcTimeSeriesDataTypeEnum, IfcTimeSeriesDataTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcTimeSeriesDataTypeEnum = new Int32Array([160]);
let prefixSumAddressIfcTimeSeriesDataTypeEnum = new Uint32Array([0, 19, 29, 41, 58, 70, 86, 107]);
let slotMapIfcTimeSeriesDataTypeEnum = new Int32Array([4, 1, 6, 3, 0, 2, 5]);
let encodedDataIfcTimeSeriesDataTypeEnum = (new TextEncoder()).encode(".PIECEWISECONSTANT..DISCRETE..NOTDEFINED..PIECEWISEBINARY..CONTINUOUS..DISCRETEBINARY..PIECEWISECONTINUOUS.");
let IfcTimeSeriesDataTypeEnumSearch = new MinimalPerfectHash(gMapIfcTimeSeriesDataTypeEnum, prefixSumAddressIfcTimeSeriesDataTypeEnum, slotMapIfcTimeSeriesDataTypeEnum, encodedDataIfcTimeSeriesDataTypeEnum);
export { IfcTimeSeriesDataTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcTimeSeriesDataTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcTimeSeriesDataTypeEnumSearch, input, cursor, endCursor);
}
